// extracted by mini-css-extract-plugin
export default {"wrapper":"Ratings_wrapper__Yq1Lo"};